export enum Acoes {
    VISUALIZAR = 0,
    ZIP = 1,
    IMPRIMIR = 2
}